import { render, staticRenderFns } from "./EvolutionUser.vue?vue&type=template&id=30c10b24&scoped=true"
import script from "./EvolutionUser.vue?vue&type=script&lang=js"
export * from "./EvolutionUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c10b24",
  null
  
)

export default component.exports